import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import MainDashboard from "./Components/MainDashboard/MainDashboard";
import Dashboard from "./Components/Dashboard/Dashboard";
import Login from "./Components/Login/Login";
import { DBConfig } from './IndexDBConfig';
import { initDB } from 'react-indexed-db';
import IdleTimer from './IdleTimer'
initDB(DBConfig);

function App() {
  return (
    <React.Fragment>
      <IdleTimer />
      <BrowserRouter>
        <Switch>
          <Route exact path="/main-dashboard" component={MainDashboard} />
          <Route exact path="/dashboard/:id" component={Dashboard} />
          <Route exact path="/dashboard/:id/:id" component={Dashboard} />
          <Route path="/" component={Login} />
        </Switch>
      </BrowserRouter>
    </React.Fragment>
  );
}

export default App;
